import React from "react";

function RadioGroup({ name, label, options, value, onChange, disabled }) {
    return (
        <div>
            {label && <p><strong>{label}</strong></p>}

            {options.map((opt) => (
                <label key={opt.value} style={{ display: "block", marginBottom: 5 }}>
                    <input
                        type="radio"
                        name={name}
                        value={opt.value}
                        disabled={disabled}
                        checked={value === opt.value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    {" "}{opt.label}
                </label>
            ))}
        </div>
    );
}

export default RadioGroup;
